module.exports = __webpack_public_path__ + "static/soehne-web-halbfett-5c8e3bb30cd36c24b356321db8e9c18d.woff";